import React from "react";
import "./css/privacy_policy.css";
import Footer from "./Footer";
import Header from "./Header";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div
        className="header"
        style={{
          backgroundImage: `url("../../../../public/new_landing_page_images/green_swoosh.svg")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundColor: "#000000",
        }}
      >
        <Header />
      </div>
      <div className="privacy-container">
        <h1 className="privacy-heading">PRIVACY POLICY FOR BRAINSTAKE:</h1>
        <p className="privacy-paragraph">
          At <strong>eSchools by Brainstake</strong> ("we", "us", "our"), your
          privacy is important to us. We are committed to protecting your
          personal data and being transparent about how we handle it. This
          Privacy Policy explains in simple and clear terms what information we
          collect, why we collect it, how we use it, and how we keep it safe. It
          also outlines your rights and how you can exercise them.
        </p>
        <br />
        <p className="privacy-paragraph">
          We follow privacy regulations in Zimbabwe, including the{" "}
          <b>Data Protection Act [Chapter 11:22] </b>and <b>SI 155 of 2024</b>,
          as well as relevant principles under South Africa’s{" "}
          <b>Protection of Personal Information Act (POPIA)</b>.
        </p>
      </div>
      <div className="privacy-policy-content">
        <h2>1. Who We Are</h2>
        <p>
          We are <b>Brainstake Solutions (Private) Limited</b>, the company
          behind the eSchools platform. Our platform helps schools across
          Zimbabwe and Southern Africa manage their data securely and
          efficiently. We are a registered Data Controller with the{" "}
          <b>
            Postal and Telecommunications Regulatory Authority of Zimbabwe
            (POTRAZ)
          </b>
          .
        </p>
        <p>
          If you use our platform, this policy applies to you whether you're a:
        </p>
        <ul>
          <li>School administrator or staff member</li>
          <li>Teacher</li>
          <li>Parent or legal guardian of a student</li>
        </ul>
        <h3>Please note:</h3>
        <p>
          We do not collect personal data directly from students. All student
          data is provided by registered schools.
        </p>

        <h2>2. Scope of This Policy</h2>
        <p>
          This Privacy Policy applies to all users of the eSchools platform:
        </p>
        <ul>
          <li>Students</li>
          <li>Parents/Guardians</li>
          <li>Teachers and staff</li>
          <li>School administrators</li>
          <li>Any other users who interact with our platform</li>
        </ul>
        <p>
          It explains how we collect, use, store, share, and secure your
          personal data.
        </p>

        <h2>3. What Information We Collect</h2>
        <p>
          Depending on how you interact with our platform, we may collect the
          following types of information:
        </p>
        <ol type="A">
          <li>
            <h4>Basic Details</h4>
            <p>
              Names, dates of birth, student ID numbers, or national ID numbers.
            </p>
          </li>
          <li>
            <h4>Contact Information</h4>
            <p>Phone numbers, email addresses, and postal addresses.</p>
          </li>
          <li>
            <h4>Academic Records</h4>
            <p>Grades, attendance, schedules, and any disciplinary history.</p>
          </li>
          <li>
            <h4>Financial Information</h4>
            <p>Payment methods, billing records, and fee statements.</p>
          </li>
          <li>
            <h4>Biometric Data (only when used by schools)</h4>
            <p>
              Fingerprint scans or facial recognition data (with parent/guardian
              consent).
            </p>
          </li>
          <li>
            <h4>Technical Data</h4>
            <p>
              Your IP address, browser type, device information, and usage logs.
            </p>
          </li>
          <li>
            <h4>Communication Data</h4>
            <p>Messages sent through our system (email, SMS, or chat).</p>
          </li>
          <li>
            <h4>Location Data</h4>
            <p><a href="#section-3a">See Section 3A below</a></p>
          </li>
        </ol>
        <h2 id="section-3a">3A. Location Data</h2>
        <p>
          Our app may collect approximate or precise location data from teachers’ mobile devices under the following conditions:
        </p>   
        <ul>
          <li>
            To enable automatic teacher attendance check-ins when a teacher is physically within the school’s geofenced area.
          </li>
          <li>
            The "Mark Attendance" button becomes active only when the teacher is on school premises.
          </li>
          <li>
            We do not track teachers continuously or outside of school boundaries.
          </li>
        </ul>
        <h4>This data is: </h4>
        <ul>
          <li>
            Not used to track you continuously 
          </li>
          <li>
            Not shared with any advertisers
          </li>
          <li>
            Not sold or rented 
          </li>
          <li>
            Only accessed with your device permission 
          </li>
          <li>
            Handled in compliance with privacy regulations
          </li>
          <li>
            You can manage or revoke location permissions at any time from your device settings 
          </li>
        </ul>
        <h4>Legal Compliance: </h4>
        <p>We process location data in accordance with:</p>
        <ul>
          <li>
            Zimbabwe’s Data Protection Act [Chapter 11:22] and SI 155 of 2024 
          </li>
          <li>
            South Africa’s POPIA 
          </li>
          <li>
            The African Union’s Malabo Convention on Cyber Security and Personal Data Protection 
          </li>
          <li>
            Any applicable local regulations governing school and education data protection
          </li>
        </ul>
        <h2>4. How We Collect Your Information</h2>
        <ul>
          <li>
            <b>From Schools:</b> Schools enter student data (including personal,
            academic, and financial details) into the system on behalf of
            parents and students.
          </li>
          <li>
            <b>From Parents or Guardians:</b> When you register or update your
            contact information.
          </li>
          <li>
            <b>Automatically:</b> When you use the platform, we collect
            technical and usage data using cookies and system logs.
          </li>
          <li>
            <b>From Trusted Third Parties:</b> For example, payment processors
            or messaging service providers.
          </li>
        </ul>

        <h2>5. Why We Collect Your Data</h2>
        <ul>
          <li>
            To manage academic and administrative tasks, like attendance,
            grades, and schedules.
          </li>
          <li>To allow communication between schools and parents.</li>
          <li>To process payments and send fee notifications.</li>
          <li>To improve the functionality and performance of our platform.</li>
          <li>To comply with laws and regulations.</li>
          <li>To protect the platform from misuse or security threats.</li>
        </ul>
        <p>We only collect data that is necessary for these purposes.</p>

        <h2>6. Legal Grounds for Using Your Data</h2>
        <p>
          We will only use your data when we are allowed to by law. The legal
          grounds we rely on include:
        </p>

        <ul>
          <li>
            <b>Consent:</b> We ask for your clear permission before collecting
            biometric data or processing children’s personal data.
          </li>
          <li>
            <b>Contractual Necessity:</b> To provide the services you expect
            from our platform.
          </li>
          <li>
            <b>Legal Obligation:</b> To meet requirements under Zimbabwean and
            South African laws.
          </li>
          <li>
            <b>Legitimate Interest:</b> To run, maintain, and improve our
            platform without overriding your rights.
          </li>
        </ul>

        <h2>7. Children’s Data and Parental Consent</h2>
        <p>
          If the user is a student under the age of 18, we will only collect and
          use their data if we have verified consent from a parent or guardian.
          In cases where schools use biometric systems (e.g., fingerprint for
          attendance), we:
        </p>
        <ul>
          <li>Always get written consent from the parent or guardian first</li>
          <li>Keep biometric data securely encrypted</li>
          <li>
            Limit access to only authorized school staff or administrators
          </li>
        </ul>
        <p>
          Parents may revoke their consent at any time by contacting us or their
          child’s school.
        </p>

        <h2>8. Who We Share Your Information With</h2>
        <p>
          We only share your information with trusted parties that help us run
          the platform. These include:
        </p>
        <ul>
          <li>
            <b>Payment Providers</b> – to handle secure transactions
          </li>
          <li>
            <b>Communication Services</b> – to send emails, SMS, or alerts
          </li>
          <li>
            <b>IT and Analytics Services</b> – to maintain and improve our
            platform
          </li>
          <li>
            <b>Regulatory Authorities</b> – like POTRAZ, if required by law
          </li>
        </ul>
        <p>
          All our partners follow strict confidentiality and data protection
          agreements. We do not sell or rent your personal data to anyone.
        </p>
        <h2>9. International Transfers</h2>
        <p>
          Sometimes your data may be stored or processed outside Zimbabwe (e.g.,
          on cloud servers or by international service providers). If this
          happens, we ensure:
        </p>
        <ul>
          <li>Your data is protected to the same high standards.</li>
          <li>The receiving country has privacy safeguards in place.</li>
          <li>
            We follow Zimbabwean and South African data transfer regulations.
          </li>
        </ul>

        <h2>10. Your Privacy Rights</h2>
        <p>You have the right to</p>
        <ul>
          <li>
            <b>Access</b> your personal data.
          </li>
          <li>
            <b>Correct</b> any mistakes or incomplete information.
          </li>
          <li>
            <b>Delete</b> your data, where allowed by law.
          </li>
          <li>
            <b>Limit or object</b> to how we process your data.
          </li>
          <li>
            <b>Withdraw consent</b> where processing is based on consent.
          </li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at{" "}
          <a href="mailto:info@brainstake.tech">info@brainstake.tech</a>.
        </p>

        <h2>11. How We Protect Your Data</h2>
        <p>
          We take your data security seriously. Some of the steps we take
          include:
        </p>
        <ul>
          <li>
            <b>Encryption:</b> to protect sensitive information in storage and
            during transfer.
          </li>
          <li>
            <b>Access Control:</b> only authorized personnel can view personal
            data.
          </li>
          <li>
            <b>Regular Security Audits:</b> to detect and fix any
            vulnerabilities.
          </li>
          <li>
            <b>Training:</b> our staff are trained in data privacy and security
            best practices.
          </li>
        </ul>

        <h2>12. How Long We Keep Your Data</h2>
        <p>
          We only keep your data for as long as it is needed for the purpose it
          was collected. This may include:
        </p>
        <ul>
          <li>Keeping academic records for regulatory or school reporting.</li>
          <li>Retaining financial data for tax or audit purposes.</li>
          <li>
            Holding on to contact details to notify you about school-related
            matters.
          </li>
        </ul>
        <p>
          When we no longer need the data, we delete or anonymize it securely.
        </p>

        <h2>13. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. If we make any
          major changes, we’ll let you know through:
        </p>
        <ul>
          <li>Email notifications</li>
          <li>Messages on our platform</li>
          <li>The updated “Last Updated” date at the top of this document</li>
        </ul>
        <p>We encourage you to review the policy periodically.</p>

        <h2>14. Contact Us</h2>
        <p>If you have any questions or concerns, you can contact us:</p>
        <h4>Brainstake Solutions (Private) Limited</h4>
        <p>
          Email: <a href="mailto:info@brainstake.tech">info@brainstake.tech</a>
        </p>
        <p>Phone: +263711951133</p>
        <p>Address: 2761 Sable Way, BluffHill, Harare</p>

        <h2>15. School and Organizational Data</h2>
        <p>
          We also protect non-personal data belonging to schools, such as class
          schedules, teacher records, and internal reports. This data is:
        </p>
        <ul>
          <li>Encrypted and stored securely.</li>
          <li>Only accessible to verified users.</li>
          <li>
            Handled in compliance with Zimbabwean and South African regulations.
          </li>
        </ul>

        <p>
          We are committed to creating a safe and transparent platform for
          education. Thank you for trusting eSchools by Brainstake.
        </p>
      </div>
      <div style={{ marginTop: "100px" }}>
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
